import { isNativePlatform } from '~/utils/native-app/capacitor'

export default defineNuxtRouteMiddleware(async (to) => {
  if (isNativePlatform() && to.path === '/') {
    return navigateTo('/native-loading')
  }
})
